import React, { useEffect, useState } from "react";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { FxLabel } from "./FxLabel";

export const FxCheckBox = props => {

  const { attr, onChangeValue, fxInObj, inputType } = props;
  const disabled = attr.readOnlyYn === 'Y';
  const [defaultValue, setDefaultValue] = React.useState(false);


  useEffect(() => {
    let val = fxInObj[attr.attrName] === true;
    if (fxInObj[attr.attrName] === 'N') val = false;
    else if (fxInObj[attr.attrName] === 'Y') val = true;

    setDefaultValue(val);
    console.log('*** FxCheckBox ***', inputType, attr.attrName, fxInObj[attr.attrName], defaultValue, fxInObj[attr.attrName] === 'Y');
  }, []);


  const onChange = (event) => {
    onChangeValue(event.target.id, event.target.checked ? "Y" : "N");
  }

  return (
    <>
      <FxLabel attr={attr} inputType={inputType} />
      <input className="FxCheckBox" type="checkbox" id={attr.attrName} defaultValue={defaultValue} disabled={disabled} checked={defaultValue}
        onChange={onChange} />
    </>
  );
}

export const FxCheckBox2 = props => {

  const { attrClass, para } = props;
  const sx = attrClass.getStyle();
  const [defaultValue, setDefaultValue] = React.useState(props.defaultValue === "N" || props.defaultValue === false ? false : true);

  sx.minWidth = '210px';
  sx.width = sx.minWidth;

  console.log('*** FxCheckBox *** defaultValue', defaultValue);

  const onChange = (event) => {
    setDefaultValue(event.target.checked);
    if (para.onChange) para.onChange(event.target.id, event.target.checked ? "Y" : "N");
  }

  return (
    <>
      <input className="FxCheckBox" type="checkbox" id={attrClass.getId()} defaultValue={defaultValue} checked={defaultValue}
        disabled={attrClass.isDisable()}
        onChange={onChange} />
    </>
  );
}

/**
 * 기본 Select 박스
 * 
 * @param {function(id, value)} onChangeValue Select박스가 선택되었을 때 호출하는 함수 function(id, value)
 * @param {*} defaultValue 기본값
 * @param {string} name ID 및 이름
 * @param {string} className css명
 * @param {boolean} disabled 비활성화여부
 * @returns 
 */
export const FxCheckBoxBase = props => {
  const { onChangeValue, name, className, disabled } = props;
  const [value, setValue] = React.useState(false);


  useEffect(() => {
    let val = true;
    if (props.defaultValue !== undefined) {
      val = props.defaultValue;
    } else if (props.selectedData !== undefined && props.selectedData[name] !== undefined) {
      val = props.selectedData[name];
    }

    if ( typeof val === 'string') {
      val = val === "Y";
    }
    
    onChangeValue(name, val ? "Y" : "N");
    setValue(val);

  }, [props.defaultValue, props.selectedData]);


  const onChange = (event) => {
    onChangeValue(event.target.id, event.target.checked ? "Y" : "N");
    setValue(event.target.checked);
  }

  return (
    <>
      <input className={className ? className : "FxCheckBox"} type="checkbox" id={name} defaultValue={value} disabled={disabled} checked={value}
        onChange={onChange} />
    </>
  );
}